/* Referral promo storage — link-driven only (no cross-visit replay). rev 2026-06-18a */
(function () {
  var __run = function () {
  const PROMO_PARAM_KEY = "promo";
  const UTM_PARAM_KEY = "utm_source";
  const UTM_CAMPAIGN_KEY = "utm_campaign";
  const REFERRAL_VALUE = "referral";
  const RESET_PARAM_KEY = "reset_storage";
  const QUIZ_PATH_PREFIX = "/pages/dog-quiz";
  const QUIZ_DISCOUNT_PARAM = "discount";
  const PROMO_APPLIED_FLAG = "promo_discount_applied";

  const PROMO_STORAGE_KEY = "promo";
  const ADVOCATE_STORAGE_KEY = "referral_advocate";
  const UTM_TERM_KEY = "utm_term";

  const params = new URLSearchParams(window.location.search);
  const pathname = (window.location.pathname || "").toLowerCase();

  function clearStored(key) {
    try {
      if (typeof localStorage !== "undefined") {
        localStorage.removeItem(key);
      }
    } catch (e) {
      // Ignore storage issues (e.g. blocked or unavailable).
    }
  }

  if (params.get(RESET_PARAM_KEY) === "true") {
    clearStored(PROMO_STORAGE_KEY);
    clearStored(ADVOCATE_STORAGE_KEY);
    return;
  }

  // Referrals are LINK-DRIVEN ONLY. A promo / advocate code is honoured solely
  // for the visit that actually arrives via a referral link; anything left in
  // storage from an earlier visit is dropped here so it can never replay onto a
  // later one. Concretely: opening a new partner link must not surface a
  // previous campaign's banner, and an ordinary (non-referral) visit must carry
  // no referral at all. This is safe mid-quiz — step changes use
  // history.pushState (no page reload, so this IIFE does not re-run) and a hard
  // refresh keeps the utm_* params in the URL, so a genuine referral journey is
  // never cleared out from under the user.
  const arrivedWithPromo =
    params.has(PROMO_PARAM_KEY) || params.get(UTM_PARAM_KEY) === REFERRAL_VALUE;
  if (!arrivedWithPromo) {
    clearStored(PROMO_STORAGE_KEY);
  }
  if (params.get(UTM_PARAM_KEY) !== REFERRAL_VALUE) {
    clearStored(ADVOCATE_STORAGE_KEY);
  }

  function getReferralPromoValue() {
    const utmCampaign = params.get(UTM_CAMPAIGN_KEY);
    if (!utmCampaign) return null;

    // Refer & Earn triggers are the last "_"-segment, e.g. referral_REFERBOX
    // -> REFERBOX, referral_SIZZLE -> SIZZLE.
    const triggerMatch = utmCampaign.match(/_([A-Za-z0-9-]+)$/);
    return triggerMatch ? triggerMatch[1] : utmCampaign;
  }

  // The advocate's personal referral code (who referred this visitor), carried
  // in utm_term on referral traffic. Persisted separately from the promo
  // trigger so attribution survives to checkout regardless of the discount path.
  function storeAdvocateCode() {
    if (params.get(UTM_PARAM_KEY) !== REFERRAL_VALUE) {
      return;
    }

    const advocateCode = params.get(UTM_TERM_KEY);
    if (!advocateCode) return;

    try {
      if (typeof localStorage !== "undefined") {
        localStorage.setItem(
          ADVOCATE_STORAGE_KEY,
          JSON.stringify({ code: advocateCode, timestamp: Date.now() })
        );
      }
    } catch (e) {
      // Ignore storage failures – attribution is a nice-to-have here.
    }
  }

  storeAdvocateCode();

  function storePromoTemporarily(value, code) {
    try {
      if (typeof localStorage !== "undefined") {
        localStorage.setItem(
          PROMO_STORAGE_KEY,
          JSON.stringify({
            value,
            code: code || null,
            timestamp: Date.now()
          })
        );
      }
    } catch (e) {
      // Ignore storage failures – promo is a nice-to-have.
    }
  }

  function getStoredPromo() {
    try {
      if (typeof localStorage === "undefined") return null;

      const raw = localStorage.getItem(PROMO_STORAGE_KEY);
      if (!raw) return null;

      const parsed = JSON.parse(raw);
      return parsed && parsed.value ? parsed : null;
    } catch {
      return null;
    }
  }

  let resolvedPromo = null;

  if (params.has(PROMO_PARAM_KEY)) {
    resolvedPromo = params.get(PROMO_PARAM_KEY);
  }
  else if (params.get(UTM_PARAM_KEY) === REFERRAL_VALUE) {
    resolvedPromo = getReferralPromoValue();
  }

  if (resolvedPromo) {
    storePromoTemporarily(resolvedPromo);
  }

  if (pathname.startsWith(QUIZ_PATH_PREFIX)) {
    const promo = getStoredPromo();
    if (promo && promo.code && !window.globalDiscountCode) {
      window.globalDiscountCode = promo.code;
    }

    let hasDiscountParam = false;
    let alreadyApplied = false;

    try {
      hasDiscountParam = params.has(QUIZ_DISCOUNT_PARAM);
      alreadyApplied =
        typeof sessionStorage !== "undefined" &&
        sessionStorage.getItem(PROMO_APPLIED_FLAG) === "true";
    } catch (e) {
      hasDiscountParam = params.has(QUIZ_DISCOUNT_PARAM);
      alreadyApplied = false;
    }

    if (promo && promo.code && !hasDiscountParam && !alreadyApplied) {
      try {
        if (typeof sessionStorage !== "undefined") {
          sessionStorage.setItem(PROMO_APPLIED_FLAG, "true");
        }
      } catch (e) {
        // Ignore session storage failures.
      }

      const url = new URL(window.location.href);
      url.searchParams.set(QUIZ_DISCOUNT_PARAM, promo.code);
      window.location.replace(url.toString());
    }
  }
  };
  if (typeof window !== 'undefined' && window.DashPrerender && window.DashPrerender.isPrerendering()) {
    window.DashPrerender.onActivate(__run);
  } else {
    __run();
  }
})();

(function () {
  // window.firstBoxOffer comes from snippets/first-box-offer.liquid; fall back
  // to 50 so the banner never renders blank or NaN.
  function firstBoxPercent() {
    const p = Math.round(Number(window.firstBoxOffer && window.firstBoxOffer.firstBoxPercent));
    return p >= 1 && p <= 100 ? p : 50;
  }

  function promoMessage(key) {
    if (key === "REFERBOX") return "Your friend sent you a free box!";
    if (key === "free_liver_50") return firstBoxPercent() + "% Off Your First Order + Free Liver Bites";
    return undefined;
  }

  async function getPromo() {
    try {
      if (typeof localStorage === "undefined") return null;

      const raw = localStorage.getItem("promo");
      if (!raw) return null;

      return JSON.parse(raw).value;
    } catch {
      return null;
    }
  }

  // A partner link's own banner copy (admin-authored, synced to
  // window.referralConfig.banners) replaces the site offer for that visit, so
  // a free-box partner never sees "50% off" above their free box. Only the
  // message span is rewritten: the bar's arrow icon is a sibling of it.
  function partnerBanner(promo) {
    const banners = window.referralConfig && window.referralConfig.banners;
    return banners && promo && typeof banners[promo] === "string" && banners[promo] ? banners[promo] : null;
  }

  async function updateBar() {
    const promo = await getPromo();
    const discountCode = window.globalDiscountCode || null;
    const html = partnerBanner(promo);
    const message = promoMessage(promo || "") || promoMessage(discountCode || "");

    if (!html && !message) return;

    const el = document.querySelector(".announcement-bar__message");
    if (!el) return;

    const span = el.querySelector("span");
    if (html && span) {
      span.innerHTML = html;
    } else if (message) {
      el.textContent = message;
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", updateBar);
  } else {
    updateBar();
  }
})();
